import { DB_ONBOARDING_ACTIONS } from "constants/actions";

export function fetchDBOnBoardingList(stage, page, page_size, filters) {
    return {
        type: DB_ONBOARDING_ACTIONS.FETCH_DB_ONBOARDING_LIST,
        payload: {
            stage,
            page,
            page_size,
            filters
        }
    };
}

export function fetchedDBOnBoardingList(stage, page, page_size, data) {
    return {
        type: DB_ONBOARDING_ACTIONS.FETCHED_DB_ONBOARDING_LIST,
        payload: {
            stage,
            page,
            page_size,
            data: data
        }
    };
}

export function failedFetchDBOnBoardingList(stage, page, page_size, error) {
    return {
        type: DB_ONBOARDING_ACTIONS.FAILED_FETCH_DB_ONBOARDING_LIST,
        payload: {
            stage,
            page,
            page_size
        },
        error: error
    };
}


export function dbOnboardingInvalidateDocumentHandler(company_id, file) {
    return {
        type: DB_ONBOARDING_ACTIONS.FETCH_DB_ONBOARDING_VALIDATE_DOCUMENT,
        payload: {
            company_id,
            file,
        }
    };
}

export function dbOnboardingInvalidatedDocument(company_id, file) {
    return {
        type: DB_ONBOARDING_ACTIONS.FETCHED_DB_ONBOARDING_VALIDATE_DOCUMENT,
        payload: {
            company_id, 
            file
        }
    };
}

export function dbOnboardingFailedInvalidateDocument(error) {
    return {
        type: DB_ONBOARDING_ACTIONS.FAILED_FETCH_DB_ONBOARDING_VALIDATE_DOCUMENT,
        error: error
    };
}